import React from 'react';
import SimplrDropdown from '../../../DropDown/SimplrDropdown/SimplrDropdown';
import { SORT_OPTIONS_LIST } from '../../../../constants/sortOptions';

export const SortOrderFilter = ({ selectedSortOrder, onSelect }) => {
  return (
    <SimplrDropdown
      selected={selectedSortOrder}
      options={SORT_OPTIONS_LIST}
      onSelect={onSelect}
      placeholder="Sort by"
    />
  );
};
